import * as MutationTypes from './mutationsTypes';

const productMasterList = (state, payload) => {
  state.productMasterList = payload;
};

const createProductMasterSuccess = (state, payload) => {
  state.createProductMasterSuccess = payload;
};

const deleteProductMasterSuccess = (state, payload) => {
  state.deleteProductMasterSuccess = payload;
};

const updateProductMasterSuccess = (state, payload) => {
  state.updateProductMasterSuccess = payload;
};

const propagateProductMasterSuccess = (state, payload) => {
  state.propagateProductMasterSuccess = payload;
};

const productSearchListUpdate = (state, { productList, count }) => {
  state.productSearchProgress += (productList.length / count) * 100;
  state.productSearchList.push(...productList);
};

const productSearchListSuccess = (state, payload) => {
  state.productSearchListSuccess = payload;
};
const productSearchProgress = (state, payload) => {
  state.productSearchProgress = payload;
};
const productSearchListCancelToken = (state, payload) => {
  state.productSearchListCancelToken = payload;
};

const productSearchListClear = (state) => {
  state.productSearchList = [];
};

export const mutations = {
  [MutationTypes.PRODUCT_MASTER_LIST]: productMasterList,
  [MutationTypes.CREATE_PRODUCT_MASTER_SUCCESS]: createProductMasterSuccess,
  [MutationTypes.DELETE_PRODUCT_MASTER_SUCCESS]: deleteProductMasterSuccess,
  [MutationTypes.UPDATE_PRODUCT_MASTER_SUCCESS]: updateProductMasterSuccess,
  [MutationTypes.PROPAGATE_PRODUCT_MASTER_SUCCESS]: propagateProductMasterSuccess,
  [MutationTypes.PRODUCT_SEARCH_LIST_UPDATE]: productSearchListUpdate,
  [MutationTypes.PRODUCT_SEARCH_PROGRESS]: productSearchListSuccess,
  [MutationTypes.PRODUCT_SEARCH_LIST_CANCEL_TOKEN]: productSearchProgress,
  [MutationTypes.PRODUCT_SEARCH_LIST_SUCCESS]: productSearchListCancelToken,
  [MutationTypes.PRODUCT_SEARCH_CLEAR_LIST]: productSearchListClear
};
